import React, { useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { downloadWorkbook } from '../ducks/bookInfo';
import ImageBox from '../../components/ImageBox';
import _ from 'lodash';

const WorkBookList = ({book, workBooks})=>{
    if(book.isService!=='Y' || null===workBooks )return null;

    return workBooks.map( (workbook, key)=>{
        return <WorkBook workbook={workbook} key={key} />
    });
}
export default WorkBookList;

const WorkBook = ({workbook})=>{
    const auth = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const onDownloadWorkbook = useCallback( ()=>{    
        dispatch( downloadWorkbook(workbook) );
    }, [dispatch, workbook]);  

    return (
        <div className="activity">
            <div className="title_wrap">
                <h4><span></span> {workbook.name} <span></span></h4>
                {auth.authenticated && 
                <button className="btn _sm _blue" onClick={onDownloadWorkbook}><strong>다운로드</strong></button>
                }
            </div>
            <div className="box clear">
                <ImageBox images={_.slice(workbook.previews, 0, 4)} />
            </div>
        </div>
    );
}